// @ts-nocheck
import { SERVER_URL } from '../../../config';
import { httpClient } from '../../../core/network';

class CampaignService {
  static fetchCampaigns(
    page = 1,
    size = 20,
    { onlyActive = true, withActiveSeries = false } = {},
    { orderBy = 'created', sortOrder = 'desc' } = {}
  ) {
    const apiUrl = '/campaigns';
    return httpClient.get(apiUrl, {
      params: {
        onlyactive: onlyActive,
        withactiveseries: withActiveSeries,
        sort: orderBy,
        sortOrder: sortOrder,
        page,
        size,
      },
    });
  }

  static fetchCampaign(campaignId) {
    const apiUrl = `/campaigns/${campaignId}`;
    return httpClient.get(apiUrl);
  }

  static fetchCampaignSeries(campaignId, onlyActive = true) {
    const apiUrl = `/campaigns/${campaignId}/series`;
    return httpClient.get(apiUrl, {
      params: { onlyActive },
    });
  }

  static createCampaign(campaignData) {
    const apiUrl = '/campaigns';
    return httpClient.post(apiUrl, campaignData, {
      headers: { client: 'commercial' },
    });
  }

  static updateCampaign(campaignId, campaignData) {
    const apiUrl = `/campaigns/${campaignId}`;
    return httpClient.put(apiUrl, campaignData, {
      headers: { client: 'commercial' },
    });
  }

  static closeCampaign(campaignId) {
    const apiUrl = `/campaigns/${campaignId}`;
    return httpClient.delete(apiUrl);
  }

  static createCampaignSeries(seriesData) {
    const apiUrl = `/campaigns/${seriesData.campaignId}/series`;
    return httpClient.post(apiUrl, seriesData, {
      headers: { client: 'commercial' },
    });
  }

  static updateCampaignSeries(seriesData) {
    const apiUrl = `/campaigns/${seriesData.campaignId}/series/${seriesData.id}`;
    return httpClient.put(apiUrl, seriesData, {
      headers: { client: 'commercial' },
    });
  }

  static getDownloadVouchersUrl(campaignSeriesId) {
    const accessToken = localStorage.getItem('access_token');
    const idToken = localStorage.getItem('id_token');
    return `${SERVER_URL}series/${campaignSeriesId}/vouchers?access_token=${accessToken}&id_token=${idToken}`;
  }

  static fetchSeriesSegments() {
    const apiUrl = '/series/segments';
    return httpClient.get(apiUrl);
  }
}

export default CampaignService;
